var _g, _g2, _g3, _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _rect4, _path5, _path6, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _path7, _path8, _rect5, _rect6, _circle, _g15, _g16, _g17, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 655.319,
    height: 533,
    viewBox: "0 0 655.319 533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_7460",
    "data-name": "Group 7460",
    transform: "translate(-211.6 -401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7244",
    "data-name": "Group 7244"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5901",
    "data-name": "Group 5901",
    transform: "translate(304.116 401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5854",
    "data-name": "Group 5854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M1164.3,506.394c5.561-2.25,9.06-9.824,7.83-18.152Q1148.095,325.42,1124.058,162.6c-1.23-8.327-6.347-14.667-12.533-16.654C1075.992,134.7,1009,112.057,974.142,101.193c-10.731-3.346-20.656,8.179-18.685,21.691l61.11,418.963c1.87,12.828,12.446,20.633,22.421,16.539C1070.032,545.645,1131.67,519.4,1164.3,506.394Z",
    transform: "translate(-955.205 -100.609)",
    fill: "#1e5160"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5855",
    "data-name": "Group 5855",
    transform: "translate(12.209 0.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M1032.992,555.16q65.01-26.07,130.027-52.139c5.38-2.2,8.768-10.573,7.572-18.715q-23.432-159.253-46.864-318.5c-1.2-8.142-7.025-16.331-13.016-18.285q-72.264-23.207-144.527-46.409c-5.994-1.955-9.552,5.273-7.955,16.141l62.121,422.193C1021.951,550.317,1027.608,557.355,1032.992,555.16Z",
    transform: "translate(-957.847 -100.795)",
    fill: "#295a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5856",
    "data-name": "Group 5856",
    transform: "translate(30.549 31.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M1015.987,489.229,1140,446.905q-21.313-150.179-42.623-300.359-67.78-19.526-135.56-39.057Q988.9,298.364,1015.987,489.229Z",
    transform: "translate(-961.816 -107.489)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5857",
    "data-name": "Group 5857",
    transform: "translate(73.007 27.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M974.7,110.569c.462,2.569,2.3,4.991,4.089,5.416s2.879-1.294,2.417-3.831-2.292-4.963-4.09-5.416S974.229,108,974.7,110.569Z",
    transform: "translate(-974.588 -106.667)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5858",
    "data-name": "Group 5858",
    transform: "translate(62.562 24.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M971.927,109.957c.471,2.611,2.31,5.069,4.108,5.49s2.87-1.326,2.4-3.909-2.306-5.042-4.1-5.49S971.452,107.346,971.927,109.957Z",
    transform: "translate(-971.815 -105.977)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5859",
    "data-name": "Group 5859",
    transform: "translate(144.628 394.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M1001.541,210.266q8.657-2.7,17.315-5.411c2.62-.827,4.214-4.519,3.549-8.2l-.929-5.116c-.67-3.688-3.373-6.1-6.007-5.36L998.061,191.1c-2.634.739-4.219,4.492-3.521,8.341q.485,2.669.97,5.328C996.208,208.616,998.921,211.093,1001.541,210.266Z",
    transform: "translate(-994.375 -186.043)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5860",
    "data-name": "Group 5860",
    transform: "translate(115.015 415.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M988.83,203.129a1.54,1.54,0,0,0,.434-.06l11.6-3.531a.732.732,0,0,0,.485-.91.721.721,0,0,0-.9-.49l-11.6,3.53a1.346,1.346,0,0,1-.61-1l-.767-4.238c-.153-.832.162-1.4.323-1.446l10.046-2.93a.738.738,0,0,0,.494-.906.723.723,0,0,0-.9-.5l-10.046,2.934c-1.035.3-1.618,1.64-1.349,3.115l.767,4.238a2.853,2.853,0,0,0,1.183,1.955A1.57,1.57,0,0,0,988.83,203.129Z",
    transform: "translate(-985.974 -190.614)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5864",
    "data-name": "Group 5864",
    transform: "translate(122.196 414.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5861",
    "data-name": "Group 5861",
    transform: "translate(0.751 0.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M987.811,190.351c.194.028,5.305,1.64,5.305,1.636q-2.149,1.962-4.293,3.942Z",
    transform: "translate(-987.811 -190.351)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5863",
    "data-name": "Group 5863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5862",
    "data-name": "Group 5862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M988.6,190.325a53.01,53.01,0,0,1,5.485,1.687c.162.051.527.277.268.518q-2.149,1.962-4.293,3.942c-.235.217-1.294.245-1.4-.323l-1.012-5.582c-.064-.36,1.386-.457,1.5.162l1.012,5.573c-.467-.106-.928-.213-1.4-.323q2.149-1.976,4.293-3.942l.273.518a49.19,49.19,0,0,0-5.129-1.58c-.171-.032-.6-.148-.522-.5C987.739,190.154,988.459,190.3,988.6,190.325Z",
    transform: "translate(-987.649 -190.269)",
    fill: "#aacbe8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5866",
    "data-name": "Group 5866",
    transform: "translate(178.047 391.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5865",
    "data-name": "Group 5865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M1006.692,198.27l12.749-3.937-.531.8q-.825-4.547-1.65-9.1c.3.176.6.351.906.522q-6.391,1.892-12.782,3.78l.532-.809q.839,4.63,1.678,9.265a.732.732,0,0,1-1.432.291q-.846-4.644-1.687-9.288a.67.67,0,0,1,.536-.809q6.391-1.872,12.786-3.748a.768.768,0,0,1,.9.522q.825,4.533,1.65,9.076a.673.673,0,0,1-.536.8q-6.37,1.982-12.745,3.969A.7.7,0,0,1,1006.692,198.27Z",
    transform: "translate(-1004.459 -185.224)",
    fill: "#aacbe8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5868",
    "data-name": "Group 5868",
    transform: "translate(172.456 388.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5867",
    "data-name": "Group 5867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M1016.748,189.172l-.688-3.8,1.086.4-10.984,3.175a6.459,6.459,0,0,0-1.71.494c.282-.18.069-.772.342-.055a8.505,8.505,0,0,1,.245,1.335q.672,3.743,1.354,7.486l-1.086-.393q2.447-.742,4.889-1.479c.559-.171,1.673.7.735.989q-2.447.742-4.884,1.488c-.24.074-.994.116-1.086-.393q-.853-4.679-1.7-9.362a.5.5,0,0,1,.351-.6l12.8-3.674c.245-.069,1-.106,1.086.393l.689,3.789c.152.832-1.312.873-1.437.2Z",
    transform: "translate(-1003.249 -184.746)",
    fill: "#aacbe8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5869",
    "data-name": "Group 5869",
    transform: "translate(30.549 31.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M963.721,121.033,1097.558,157.2l-1.5-10.656q-67.122-19.526-134.245-39.057Q962.767,114.261,963.721,121.033Z",
    transform: "translate(-961.816 -107.489)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5871",
    "data-name": "Group 5871",
    transform: "translate(33.008 45.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M964.434,123.669q66.558,14.847,133.121,29.686-.843-5.365-1.689-10.735l-133.517-32.2Q963.389,117.04,964.434,123.669Z",
    transform: "translate(-962.348 -110.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5872",
    "data-name": "Group 5872",
    transform: "translate(35.411 58.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M966.982,142.645c44.069,9.03,87.609,15.375,131.678,24.4-1.078-7.7-1.373-16.7-2.456-24.4L962.868,113.287Z",
    transform: "translate(-962.868 -113.287)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5882",
    "data-name": "Group 5882",
    transform: "translate(83.861 109.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5873",
    "data-name": "Group 5873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M1004.647,254.35l84.644-2.925q-10.377-57.206-20.753-114.408l-87.495-12.8Q992.847,189.279,1004.647,254.35Z",
    transform: "translate(-981.043 -124.212)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5874",
    "data-name": "Group 5874",
    transform: "translate(28.827 91.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M990.27,182.5s-2.759-16.47-2.953-20.074.36-9.394,2.435-12.468c2.075-3.1,10.374-5.984,10.374-5.98q9.579,4.623,19.117,9.02,7.972-4.249,15.98-8.267c0,.009,9.381,3.078,12.537,5.947,3.161,2.888,5.717,8.128,6.76,11.377s3.97,18.082,3.97,18.082Z",
    transform: "translate(-987.281 -143.977)",
    fill: "#295a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5875",
    "data-name": "Group 5875",
    transform: "translate(28.703 17.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M1008.653,132.271c0-.018,6.313-2.338,12.31,4.981,8.068,9.866,15.014,24.649,22.107,68.955-.046-.24-27.273,13.729-43.692,3.849q-2.793-2.135-5.587-4.307c.014.069-8.285-37.98-6.2-58.258C989.66,127.442,999.462,123.681,1008.653,132.271Z",
    transform: "translate(-987.254 -127.943)",
    fill: "#295a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5876",
    "data-name": "Group 5876",
    transform: "translate(41.672 71.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M998.046,154.423c2.311-3.692.605-14.773.605-14.778l10.855.559s2.061,10.961,5.721,14.723,9.93,5.49,9.93,5.49c0-.032-3.045,13.341-15.046,13.41s-20.046-14.131-20.051-14.164C990.061,159.663,995.736,158.106,998.046,154.423Z",
    transform: "translate(-990.061 -139.645)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5877",
    "data-name": "Group 5877",
    transform: "translate(64.845 54.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M995.742,136.4s2.874-1.409,3.531,1.567-1.506,8.928-3.239,8.6c-1.738-.351-.582-9.884-.578-9.871",
    transform: "translate(-995.076 -136.07)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5878",
    "data-name": "Group 5878",
    transform: "translate(35.972 52.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M991.755,136s-3.53-1.553-2.838,1.576,5.555,9.362,7.13,8.974c1.58-.36-3.868-10.226-3.873-10.245",
    transform: "translate(-988.827 -135.619)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5879",
    "data-name": "Group 5879",
    transform: "translate(50.06 71.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M1004.122,143.055c0-.028-4.732,9.829-12.246,10.55,0,0,1.636-4.441.2-13.96Q998.11,141.378,1004.122,143.055Z",
    transform: "translate(-991.876 -139.645)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5880",
    "data-name": "Group 5880",
    transform: "translate(37.414 40.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M990.949,146.9c2.246,12.375,10.088,22.629,17.514,22.9s11.714-9.071,9.575-20.869c-.4-2.167-1.724-9.778-3.456-11.294-6.3-5.485-21.6-6.382-25.245-1.1C988.495,137.747,990.607,145.016,990.949,146.9Z",
    transform: "translate(-989.14 -133.018)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5881",
    "data-name": "Group 5881",
    transform: "translate(35.616 25.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M990.094,154.281l20.966,1.705q-.964-5.317-1.927-10.628,1.7,5.462,3.392,10.9,3.736.388,7.467.781c0,.009-5.1-18.322-9.718-22.86-3.188-3.091-16.229-8.253-19.524.083a32.055,32.055,0,0,0-.55,20.61",
    transform: "translate(-988.75 -129.737)",
    fill: "#295a6e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5885",
    "data-name": "Group 5885",
    transform: "matrix(1, -0.017, 0.017, 1, 52.747, 154.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M969.731,145.48q21.274,1.622,42.541,3.239-.508-4.145-1.019-8.29-21.316-1.975-42.629-3.96Q969.179,140.975,969.731,145.48Z",
    transform: "translate(-968.623 -136.469)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5886",
    "data-name": "Group 5886",
    transform: "matrix(1, -0.017, 0.017, 1, 55.369, 170.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M970.387,149.1q21.151.943,42.3,1.895-.512-4.145-1.018-8.29-21.2-1.31-42.39-2.616Z",
    transform: "translate(-969.278 -140.084)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5887",
    "data-name": "Group 5887",
    transform: "matrix(1, -0.017, 0.017, 1, 57.997, 187.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M971.037,152.709l42.06.555q-.511-4.145-1.016-8.29L969.934,143.7Z",
    transform: "translate(-969.934 -143.698)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5888",
    "data-name": "Group 5888",
    transform: "matrix(1, -0.017, 0.017, 1, 60.622, 204.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M971.694,156.378l41.818-.79q-.51-4.145-1.017-8.29l-41.906.069Q971.141,151.873,971.694,156.378Z",
    transform: "translate(-970.589 -147.298)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5889",
    "data-name": "Group 5889",
    transform: "matrix(1, -0.017, 0.017, 1, 63.23, 219.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M972.347,161.043l41.575-2.13q-.509-4.145-1.015-8.29l-41.663,1.409Z",
    transform: "translate(-971.245 -150.622)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5892",
    "data-name": "Group 5892",
    transform: "translate(72.416 248.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M973.609,170.982q58.039-4.575,116.078-9.145-.564-3.688-1.123-7.375l-116.325,7.514Q972.924,166.474,973.609,170.982Z",
    transform: "translate(-972.238 -154.462)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5893",
    "data-name": "Group 5893",
    transform: "translate(74.426 262.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M974.251,176.889q57.769-6.065,115.537-12.135-.563-3.688-1.122-7.375-57.891,5.254-115.781,10.5Q973.564,172.383,974.251,176.889Z",
    transform: "translate(-972.885 -157.379)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5894",
    "data-name": "Group 5894",
    transform: "translate(53.76 275.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    d: "M974.9,182.8l115-15.125q-.563-3.688-1.121-7.375L973.531,173.785Q974.215,178.29,974.9,182.8Z",
    transform: "translate(-950.851 -160.296)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5895",
    "data-name": "Group 5895",
    transform: "translate(172.001 246.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6606",
    "data-name": "Path 6606",
    d: "M1003.264,159.545c.531,2.934,2.768,5.189,5,5.037s3.609-2.629,3.082-5.522-2.763-5.148-5-5.037S1002.733,156.606,1003.264,159.545Z",
    transform: "translate(-1003.15 -154.019)",
    fill: "#295a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5896",
    "data-name": "Group 5896",
    transform: "translate(79.982 297.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M975.848,192.086l113.629-19.824q-.554-3.688-1.111-7.375L974.491,183.075Q975.172,187.581,975.848,192.086Z",
    transform: "translate(-974.491 -164.887)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5897",
    "data-name": "Group 5897",
    transform: "translate(82.016 310.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6608",
    "data-name": "Path 6608",
    d: "M976.5,197.994q56.543-11.409,113.085-22.814l-1.11-7.375Q1031.8,178.4,975.137,188.983Z",
    transform: "translate(-975.137 -167.805)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5898",
    "data-name": "Group 5898",
    transform: "translate(84.06 324.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    "data-name": "Path 6609",
    d: "M977.143,203.9l112.546-25.8-1.113-7.38q-56.394,12.082-112.792,24.168Z",
    transform: "translate(-975.784 -170.723)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5900",
    "data-name": "Group 5900",
    transform: "translate(180.428 294.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    "data-name": "Path 6611",
    d: "M1005.089,170.174c.536,2.939,2.745,5.055,4.944,4.727s3.549-2.939,3.022-5.836-2.736-5.009-4.94-4.727S1004.558,167.235,1005.089,170.174Z",
    transform: "translate(-1004.974 -164.313)",
    fill: "#295a6e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5929",
    "data-name": "Group 5929",
    transform: "translate(211.6 577.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5903",
    "data-name": "Group 5903",
    transform: "translate(72.156 44.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5902",
    "data-name": "Group 5902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6612",
    "data-name": "Path 6612",
    d: "M991.049,190.416s-9.13-19.287-12.55-25.466c-1.481-2.692-3.379-5.928-8.776-10.83-3.189-2.9-4.949-3.528-13.114-5.778,1.713,6.662,20.435,42.006,24.575,47.39C985.528,201.375,991.049,190.416,991.049,190.416Z",
    transform: "translate(-956.609 -148.342)",
    fill: "#7f65c1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5905",
    "data-name": "Group 5905",
    transform: "translate(118.891 44.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5904",
    "data-name": "Group 5904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    "data-name": "Path 6613",
    d: "M966.042,159.035c-.346-.014-2.4-3.725-2.549-5.452-.109-1.339.734-5.017,1.346-5.194s.53.653.53.653.38-.741.836-.394c.286.211.021,1.992.224,3.284.123.8.667,1.6.612,2.128,0,0,.578-1.557,1.019-1.319s.028,3.127-.408,3.95c-.116.211-.435,2.937-.584,3.318C966.831,160.592,966.423,159.055,966.042,159.035Z",
    transform: "translate(-963.484 -148.366)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5908",
    "data-name": "Group 5908",
    transform: "translate(0 317.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5906",
    "data-name": "Group 5906",
    transform: "translate(0 3.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    "data-name": "Path 6614",
    d: "M965.465,194.037c1.061-4.623-5.473-3.719-9.157-5,1.087.748,2.155,1.8.387,2.243-2.583.653-8.178-.36-9.776-2.284a12.027,12.027,0,0,0-.924,4.63C945.961,195.342,964.724,197.259,965.465,194.037Z",
    transform: "translate(-945.995 -188.999)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5907",
    "data-name": "Group 5907",
    transform: "translate(0.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    d: "M955.907,194.2c1.768-.442.7-1.5-.387-2.243-2.291-.789-4.215-1.36-4.636-1.57a2.754,2.754,0,0,1-1.394-1.6l-1.156-.285s-2.013,3.018-2.2,3.419C947.729,193.839,953.324,194.852,955.907,194.2Z",
    transform: "translate(-946.131 -188.496)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5911",
    "data-name": "Group 5911",
    transform: "translate(71.381 318.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5909",
    "data-name": "Group 5909",
    transform: "translate(0 3.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    "data-name": "Path 6616",
    d: "M975.965,194.3c1.061-4.623-5.466-3.719-9.157-5,1.094.748,2.162,1.8.387,2.244-2.583.653-8.178-.36-9.776-2.284a12.118,12.118,0,0,0-.924,4.63C956.461,195.608,975.224,197.525,975.965,194.3Z",
    transform: "translate(-956.495 -189.265)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910",
    transform: "translate(0.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    d: "M966.407,194.466c1.775-.442.707-1.5-.387-2.243-2.284-.789-4.208-1.36-4.636-1.57a2.729,2.729,0,0,1-1.387-1.6l-1.162-.286s-2.013,3.018-2.2,3.42C958.229,194.105,963.824,195.118,966.407,194.466Z",
    transform: "translate(-956.631 -188.762)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5912",
    "data-name": "Group 5912",
    transform: "translate(0.858 101.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    "data-name": "Path 6618",
    d: "M976.039,156.853c-.081.564-11.863,12.543-18.076,26.826-9.687,22.257-13.209,164.333-11.373,188.875.245,3.311,8.192.5,8.613-3.583,2.638-25.6,39.008-156.461,39.008-156.461l24.582,162.933,7.981.476s2.461-209.052-1.027-215.368C1018.3,158.485,987.793,156.6,976.039,156.853Z",
    transform: "translate(-946.121 -156.831)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5914",
    "data-name": "Group 5914",
    transform: "translate(48.947 103.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5913",
    "data-name": "Group 5913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    d: "M984,158.632c-3.114-.857-7.533-1.108-17.044-1.5h3.331l-17.091,53.645s11.666,89.764,24.582,162.933l7.981.476S1004.576,229.076,984,158.632Z",
    transform: "translate(-953.195 -157.13)",
    fill: "#3b2b5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5915",
    "data-name": "Group 5915",
    transform: "translate(25.457 40.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6620",
    "data-name": "Path 6620",
    d: "M1010.131,158.058c-3.99-5.7-26.9-11.319-41.551-10.007-3.589.32-12.339,5.432-14.255,7.845-6.275,7.92-4.2,24.623-4.439,31.34-.292,8.661,2.094,20.082.809,28.954-1.944,13.372,50.463,3.589,51.748-1.04,2.549-9.191,3.623-16.1,4.718-29.824C1008.431,169.3,1010.131,158.058,1010.131,158.058Z",
    transform: "translate(-949.74 -147.859)",
    fill: "#aacbe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5918",
    "data-name": "Group 5918",
    transform: "translate(59.809 30.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5916",
    "data-name": "Group 5916",
    transform: "translate(0 0.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6621",
    "data-name": "Path 6621",
    d: "M957.215,146.4S954,157,954.978,158.291s4.84,3.188,7.4.673,1.074-12.1,1.074-12.1Z",
    transform: "translate(-954.793 -146.401)",
    fill: "#ff97a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5917",
    "data-name": "Group 5917",
    transform: "translate(0.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    "data-name": "Path 6622",
    d: "M954.855,154.661a12.843,12.843,0,0,0,8.511,1.081,30.735,30.735,0,0,0,0-5.867l-6.254-3.562C956.691,147.843,955.216,152.873,954.855,154.661Z",
    transform: "translate(-954.855 -146.313)",
    fill: "#c95d77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5919",
    "data-name": "Group 5919",
    transform: "translate(57.278 17.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    d: "M971.569,155.154c.1-1.421-1.366-5.391-2.27-7.247-.381-.775-1.706-3.025-2.522-3.263-4.391-1.258-10.789,4.63-11.781,6.132-1.21,1.815-.238,4.263.442,6.1s5.561,10.4,11.264,7.709C972.9,161.646,971.97,159.063,971.569,155.154Z",
    transform: "translate(-954.421 -144.469)",
    fill: "#ff97a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5920",
    "data-name": "Group 5920",
    transform: "translate(30.302 44.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M950.709,156.21c-1.115,4.541,1.584,9.15,4.65,14.643,6.248,11.169,21.122,24.018,25.548,27.961,8.375,7.451,16.207-4.242,16.207-4.242s-15.69-14.976-24.093-28.043c-2.012-3.12-9.463-15.378-12.386-17.363C956.589,146.42,951.681,152.253,950.709,156.21Z",
    transform: "translate(-950.452 -148.457)",
    fill: "#6e57b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5921",
    "data-name": "Group 5921",
    transform: "translate(62.829 43.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M978.256,155.847c-1.842-2.631-7.458-5.051-14.786-7.159-.476-.136-1.883-.449-1.883-.449s4.677,17.934,1.557,34.725c-3.651,19.606-7.907,35.283-7.907,35.283a3.918,3.918,0,0,0,1.074-.047c8.137-1.618,13.834-3.746,14.256-5.262,2.549-9.191,3.623-16.1,4.718-29.824C976.556,167.091,978.256,155.847,978.256,155.847Z",
    transform: "translate(-955.237 -148.24)",
    fill: "#d5eaf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5923",
    "data-name": "Group 5923",
    transform: "translate(94.985 52.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5922",
    "data-name": "Group 5922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    "data-name": "Path 6626",
    d: "M975.447,156.152c-3.481,5.955-15.48,32.618-15.48,32.618s6.248,11.5,12.019,5.914c6.37-6.166,5.132-6.859,12.407-17.736,3.739-5.581,8.729-12.883,6.954-19.2-1.563-5.561-7.125-8.233-7.125-8.233S978.921,150.19,975.447,156.152Z",
    transform: "translate(-959.967 -149.517)",
    fill: "#7f65c1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5924",
    "data-name": "Group 5924",
    transform: "translate(8.13 40.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M998.307,148.165s3.345,57.812-4.684,73.761c0,0-13.372,33.413-20.286,35.371s-26.085-5.085-26.085-5.085-2.114-14.331,18.423-39.6c0,0-5.764-41.7,1.006-54.012,2.78-5.065,10.394-9.783,16.676-10.442A91.145,91.145,0,0,1,998.307,148.165Z",
    transform: "translate(-947.191 -147.84)",
    fill: "#6e57b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5925",
    "data-name": "Group 5925",
    transform: "translate(70.831 43.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M956.414,148.3s6.146,17.872,4.432,42.455-2.842,24.922-2.842,24.922,8.654,31.217,11.781,34.583,14.3-6.649,14.3-6.649-12.978-30.354-13.569-30.089l-2.162-29.545,3.9-27.961S970.038,151.3,956.414,148.3Z",
    transform: "translate(-956.414 -148.297)",
    fill: "#7f65c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5926",
    "data-name": "Group 5926",
    transform: "translate(123.658 81.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    d: "M975.131,157.159c.041-.034,1.169-.5.857-1.088-.13-.252-1.557.007-1.774.082.578-.32.932-.823.632-1.074-.36-.3-4.372.965-4.521,1.061.36-.469,1.435-1.7,1.2-2.169a.247.247,0,0,0-.2-.156,6.37,6.37,0,0,0-1.924,1.632,18.4,18.4,0,0,0-1.578,2.257,19.363,19.363,0,0,0-1.1,2.06,3.371,3.371,0,0,0-2.42,1.339c-.218.483-.11.075.143.564.047.1.129.136.2.211a1.074,1.074,0,0,0-.279-.034c-.1-.027-.129.109-.061.17a9.471,9.471,0,0,0,6.669-.374c.55-.218,1.108-.462,1.625-.727a4.409,4.409,0,0,1,.5-.252c.075-.034.163-.081.272-.143s.265-.129.394-.2a7.366,7.366,0,0,0,1.387-1.326c.177-.435-.238-.489-.374-.5.013-.034,1-.646.986-.952C975.729,156.962,975.233,157.254,975.131,157.159Z",
    transform: "translate(-964.185 -153.814)",
    fill: "#ff97a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5927",
    "data-name": "Group 5927",
    transform: "translate(60.326 82.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M1016.388,168.581c-7.193,6.887-66.922,4.12-61.123-4.854a8.231,8.231,0,0,0-.02-8.987l57.819-.728S1029.08,156.412,1016.388,168.581Z",
    transform: "translate(-954.869 -154.012)",
    fill: "#6e57b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5928",
    "data-name": "Group 5928",
    transform: "translate(48.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M981.7,173.429c-1.115-2.944-3.12-6.662-2.991-5.812.516,3.263,1.224,7.764-3.406,9.755-4.174,1.788-7.539,1.4-10.109-2.039a28.969,28.969,0,0,1-2.557-7.206c-.129-.958.428-3.419,2.352-3.793,4.344-.85,7.757-1.74,11.285-4.541,2.107-1.659,3.08-5.078,3.127-7.682a12.194,12.194,0,0,0-3.426-9.769c-.789-.829-2.135-.537-1.693.544,2.685,6.282-7.512,5.255-10.007,4.575-1.441-.387-2.74-1.183-4.289-1.006a7.218,7.218,0,0,0-4.589,2.889c-2.644,3.236-3.249,7.866-.469,11.136-1.2.612-1.741,1.89-1.108,4.29a19.433,19.433,0,0,0,7.838,10.49,29.257,29.257,0,0,0,.625,4.868,4.989,4.989,0,0,0,1.142,2.821c1.917,1.781,7.43,2.359,9.878,2.3,2.352-.075,7.029-.9,8.375-3.25C983.027,179.67,983.075,176.788,981.7,173.429Z",
    transform: "translate(-953.104 -141.863)",
    fill: "#3b2b5b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967",
    transform: "translate(716.86 599.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5931",
    "data-name": "Group 5931",
    transform: "translate(140.113 184.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5930",
    "data-name": "Group 5930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M1023.011,172.9c.4-.153,4.759,2.6,5.769,4.467.776,1.449,1.62,6.017,1.01,6.512s-.909-.47-.909-.47-.07,1.023-.749.864c-.426-.1-.991-2.23-1.855-3.59-.521-.839-1.525-1.468-1.722-2.09,0,0,.108,2.04-.508,1.989s-1.557-3.5-1.461-4.645C1022.649,175.176,1022.287,173.174,1023.011,172.9Z",
    transform: "translate(-1022.55 -172.895)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5934",
    "data-name": "Group 5934",
    transform: "translate(117.691 325.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5932",
    "data-name": "Group 5932",
    transform: "translate(0 2.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M1036.155,199.432c.693-4.117-4.994-2.98-8.3-3.908,1,.6,1.989,1.468.457,1.951-2.236.705-7.2.114-8.711-1.5a10.592,10.592,0,0,0-.565,4.124C1019.082,201.6,1035.672,202.3,1036.155,199.432Z",
    transform: "translate(-1019.021 -195.524)",
    fill: "#3b2b5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5933",
    "data-name": "Group 5933",
    transform: "translate(0.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M1027.823,199.718c1.532-.483.54-1.353-.457-1.951-2.052-.578-3.768-.979-4.155-1.137a2.418,2.418,0,0,1-1.3-1.334l-1.036-.191s-1.608,2.757-1.76,3.113C1020.618,199.832,1025.586,200.423,1027.823,199.718Z",
    transform: "translate(-1019.112 -195.105)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5937",
    "data-name": "Group 5937",
    transform: "translate(42.587 322.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5935",
    "data-name": "Group 5935",
    transform: "translate(0 2.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M1007.26,198.932c-.7-4.111,4.993-2.973,8.3-3.9-.991.6-1.983,1.468-.458,1.951,2.243.705,7.211.108,8.711-1.5a10.606,10.606,0,0,1,.572,4.124C1024.325,201.111,1007.742,201.8,1007.26,198.932Z",
    transform: "translate(-1007.201 -195.031)",
    fill: "#3b2b5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5936",
    "data-name": "Group 5936",
    transform: "translate(7.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M1009.107,199.23c-1.525-.483-.534-1.353.458-1.951,2.052-.578,3.774-.979,4.155-1.137a2.416,2.416,0,0,0,1.309-1.334l1.036-.2s1.607,2.764,1.754,3.12C1016.318,199.338,1011.35,199.935,1009.107,199.23Z",
    transform: "translate(-1008.32 -194.611)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5938",
    "data-name": "Group 5938",
    transform: "translate(51.186 133.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M1067.617,167.057c.045.5,6.583,10.166,11.31,23.038,7.364,20.065,3.132,145.091.254,166.553-.387,2.9-7.224,0-7.383-3.6-1-22.632-26.208-139.525-26.208-139.525l-30,141.869h-7.039s3.939-101.626,8.443-155.6c1.481-17.815,7.3-33.2,8.145-34.532C1031.789,163.842,1057.3,166.218,1067.617,167.057Z",
    transform: "translate(-1008.554 -164.818)",
    fill: "#30193b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5939",
    "data-name": "Group 5939",
    transform: "translate(87.842 135.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M1036.73,165.187c.045.5,6.583,10.166,11.31,23.038,7.364,20.065,3.132,145.091.254,166.553-.2,1.544-2.242,1.442-4.129.464-.807-.419-.159-44.7-10.827-96.378-4.015-19.436-7.427-38.261-11.207-53.624-5.229-21.227-9.931-35.783-6.8-35.676C1024.112,169.87,1032.054,164.806,1036.73,165.187Z",
    transform: "translate(-1014.323 -165.167)",
    fill: "#3b2b5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5940",
    "data-name": "Group 5940",
    transform: "translate(67.762 74.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M1023.6,160.117c5.1-3.755,11.646-7.459,37.27-1a26.559,26.559,0,0,1,7.427,3.139c-2.122,8.679.769,20.465.769,20.465a88.991,88.991,0,0,0-6.671,17.726c-1.989,7.364-4.371,23.731-4.371,23.731s-17.663.642-26.2,0c-7.014-.521-20.712-4.467-20.662-8.7a175.433,175.433,0,0,1,3.577-33.356C1017.771,168.295,1023.6,160.117,1023.6,160.117Z",
    transform: "translate(-1011.163 -155.596)",
    fill: "#ffe5b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5941",
    "data-name": "Group 5941",
    transform: "translate(105.058 70.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M1017.033,154.969Z",
    transform: "translate(-1017.033 -154.969)",
    fill: "#3b2b5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5942",
    "data-name": "Group 5942",
    transform: "translate(117.523 81.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M1026.111,156.62c6.271,6.061,7.268,9.175,9.854,14.48,5.273,10.788,10.547,42.671,11.233,48.218,1.29,10.5-17.333-11.6-17.333-11.6s.368-8.546-5.21-22.034c-1.334-3.221-5.661-12.065-5.661-12.065A142.361,142.361,0,0,0,1026.111,156.62Z",
    transform: "translate(-1018.995 -156.62)",
    fill: "#357a5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5943",
    "data-name": "Group 5943",
    transform: "translate(128.382 129.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M1040.743,214.287c5.5-9-3.952-57.106-11.887-49.113-4.155,4.193-8.152,1.569-8.152,1.569l4.416,47.226S1031.035,230.171,1040.743,214.287Z",
    transform: "translate(-1020.704 -164.282)",
    fill: "#357a5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5946",
    "data-name": "Group 5946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5944",
    "data-name": "Group 5944",
    transform: "translate(0.876 1.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M1001.037,149.549c-1.105-2.516.2-6,2.376-5.286a14.792,14.792,0,0,1,1.976,1.417c.616.483,1.131.909,1.131.909s-1.391-1.913-.623-2.122,1.505.756,1.97,1.595,3.526,5.077,2.128,8.234c.28-.108-.705.578-1.093.527C1006.87,154.537,1002.232,152.275,1001.037,149.549Z",
    transform: "translate(-1000.636 -144.169)",
    fill: "#ff97a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5945",
    "data-name": "Group 5945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M1000.868,143.861s-1.525-.127,1.62,2.726l4.225,1.214S1001.991,144.051,1000.868,143.861Z",
    transform: "translate(-1000.498 -143.86)",
    fill: "#ff97a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5947",
    "data-name": "Group 5947",
    transform: "translate(97.498 75.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M1026.522,155.729s-13.088,67.583-10.286,87.229a4.935,4.935,0,0,0,4.314,4.238l21.475,2.535s-1.163-13.355-1.989-17.746c-.915-4.854-5.083-19.086-5.083-19.086l15.954-40.93s-3.571-7.828-8.19-11.545C1039.42,157.775,1035.055,156.949,1026.522,155.729Z",
    transform: "translate(-1015.843 -155.729)",
    fill: "#357a5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5948",
    "data-name": "Group 5948",
    transform: "translate(99.79 73.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M1016.2,209.52l13.546-31.063-3.145-2,5.8-1.423-1.512-11.5a8.983,8.983,0,0,0-6.658-7.612,24.46,24.46,0,0,0-3.139-.546l1.442,3.577a6.674,6.674,0,0,1,.33,3.92l-5.235,21.513Z",
    transform: "translate(-1016.204 -155.381)",
    fill: "#1f6864"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5950",
    "data-name": "Group 5950",
    transform: "translate(9.182 7.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5949",
    "data-name": "Group 5949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M1016.677,150.325c4.091,5.222,23.584,36.336,23.584,36.336s-3.374,12.707-9.371,8.291c-6.621-4.867-14.226-12.44-23.191-20.509-6.569-5.915-6.055-19.575-5.375-26.12a3.525,3.525,0,0,1,4.117-3.151C1009.656,145.782,1014.205,147.173,1016.677,150.325Z",
    transform: "translate(-1001.943 -145.112)",
    fill: "#1f6864"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5952",
    "data-name": "Group 5952",
    transform: "translate(32.081 43.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5951",
    "data-name": "Group 5951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M1013.52,150.752s25.237,18.406,31.66,22.644c2.8,1.843,6.615,4.181,17.651,8.2,3.373,1.226-6.958,4.32-5.1,13.546-7.065-2.37-45.117-28.826-50.632-33.814C1001.321,156.1,1013.52,150.752,1013.52,150.752Z",
    transform: "translate(-1005.547 -150.752)",
    fill: "#1f6864"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5953",
    "data-name": "Group 5953",
    transform: "translate(69.395 74.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    d: "M1042.146,160.4s-16.863,47.76-11.7,63.771c0,0-14.111-1.2-18.425-5.617s15.954-62.958,15.954-62.958Z",
    transform: "translate(-1011.42 -155.597)",
    fill: "#f9cb9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5954",
    "data-name": "Group 5954",
    transform: "translate(60.386 71.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    "data-name": "Path 6650",
    d: "M1047.329,157.436c-.013,0-20.77,56.719-23.655,85.526a2.135,2.135,0,0,1-3.037,1.728L1010,242.816l6.779-33.788s1.57-21.126,2.567-26.279c.381-1.944,1.347-7.7,2.776-12.942.661-2.427-5.826-8.673-5.826-8.673s9.81-5.966,13.514-5.966c12.561,0,17.682,1.283,17.682,1.283Z",
    transform: "translate(-1010.002 -155.168)",
    fill: "#1f6864"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5955",
    "data-name": "Group 5955",
    transform: "translate(80.196 71.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M1015.286,204.811s14.7-46.832,16.043-48.027c0,0,1.938-1.963-1.5-1.563s-7.923,2.8-10.941,7.237-3.838,5.559-3.838,5.559l3.768,3.132-5.7,1.258Z",
    transform: "translate(-1013.12 -155.168)",
    fill: "#357a5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5956",
    "data-name": "Group 5956",
    transform: "translate(96.963 79.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M1015.759,157.188l1,3.4,1.62.3,3.037-2.827S1018.555,154.856,1015.759,157.188Z",
    transform: "translate(-1015.759 -156.337)",
    fill: "#3b2b5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5957",
    "data-name": "Group 5957",
    transform: "translate(85.952 80.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    "data-name": "Path 6653",
    d: "M1027.711,157.942s-1.544,22.625-1.76,30.51-.381,11.265-.381,11.265l-7.923,2.059-3.621-5.667s9.682-35.161,12.548-38.2S1027.711,157.942,1027.711,157.942Z",
    transform: "translate(-1014.026 -156.569)",
    fill: "#3b2b5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5960",
    "data-name": "Group 5960",
    transform: "translate(97.601 67.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5958",
    "data-name": "Group 5958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6654",
    "data-name": "Path 6654",
    d: "M1023.722,155.6s.058,9.759-1.092,10.6-4.873,1.455-6.4-1.315,2.122-10.477,2.122-10.477Z",
    transform: "translate(-1015.859 -154.409)",
    fill: "#ff97a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5959",
    "data-name": "Group 5959",
    transform: "translate(0.893 0.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M1022.716,162.126c-2.224.343-5.089-1.519-6.716-4.136.293-1.709.2-.7.737-2.078l6.169-1.4C1022.875,155.906,1022.856,160.525,1022.716,162.126Z",
    transform: "translate(-1016 -154.508)",
    fill: "#c95d77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5961",
    "data-name": "Group 5961",
    transform: "translate(96.943 40.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M1015.776,174.548c.026-.165.337-15.579.858-17.009a13.941,13.941,0,0,1,2.847-5.362c2.891-2.91,10.09-2.758,12.7,1.169,1.411,2.116,2.891,8.793,7.358,6.925,0,0,3.348-2.268,1.862,1.048-1.855,4.149-5.064,4.537-5.064,4.537s-4.854,12.771-8.984,12.733C1027.054,178.583,1015.2,178.3,1015.776,174.548Z",
    transform: "translate(-1015.756 -150.174)",
    fill: "#ffcb48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5962",
    "data-name": "Group 5962",
    transform: "translate(96.794 55.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M1016.111,159.993c-.025-1.207,1.6-4.359,2.433-5.9a2.578,2.578,0,0,1,1.614-1.315c3.755-.9,9.339,2.827,10.121,4.13.953,1.576.045,3.609-.6,5.134s-5.083,8.584-9.8,6.093C1014.746,165.425,1015.628,163.277,1016.111,159.993Z",
    transform: "translate(-1015.732 -152.642)",
    fill: "#ff97a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963",
    transform: "translate(95.646 73.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6658",
    "data-name": "Path 6658",
    d: "M1017.8,155.4s-.687,2.008,2.541,6.068l-3.729,2.135S1013.571,161.237,1017.8,155.4Z",
    transform: "translate(-1015.552 -155.404)",
    fill: "#ffe5b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5964",
    "data-name": "Group 5964",
    transform: "translate(100.121 74.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    d: "M1021.428,155.61s.045,1.08-5.172,4.721l2.027,4.143S1024.2,162.275,1021.428,155.61Z",
    transform: "translate(-1016.256 -155.61)",
    fill: "#f9cb9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5966",
    "data-name": "Group 5966",
    transform: "translate(100.667 39.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5965",
    "data-name": "Group 5965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6660",
    "data-name": "Path 6660",
    d: "M1016.342,152.483a8.312,8.312,0,0,1,5.877-1.627,8.49,8.49,0,0,1,5.489,2.141,6.8,6.8,0,0,1,1.551,2.484c.426.972.845,1.982,1.391,2.961a7.07,7.07,0,0,0,2.326,2.649,3.987,3.987,0,0,0,3.711.178l.019-.006.108-.064a5.7,5.7,0,0,1,1.061-.559,2.75,2.75,0,0,1,.286-.083.35.35,0,0,1-.229-.184c-.038-.076-.012-.083-.025-.025a6.543,6.543,0,0,1-.953,2.192,7.087,7.087,0,0,1-1.665,1.912,5.386,5.386,0,0,1-2.167,1.08l-.076.019a.6.6,0,0,0-.419.343c-.763,1.855-1.557,3.7-2.4,5.528l-1.246,2.745a12.976,12.976,0,0,1-1.493,2.592,10.176,10.176,0,0,0,1.875-2.376c.547-.851,1.08-1.709,1.569-2.6.979-1.766,1.913-3.552,2.827-5.362l-.489.369a6.477,6.477,0,0,0,2.828-1.252,8.517,8.517,0,0,0,2.058-2.211,11.019,11.019,0,0,0,.718-1.315,4.353,4.353,0,0,0,.489-1.614,1.364,1.364,0,0,0-.133-.712,1.1,1.1,0,0,0-.769-.578,2,2,0,0,0-1.08.121,6.9,6.9,0,0,0-1.4.718l.127-.07a2.512,2.512,0,0,1-2.395-.057,5.9,5.9,0,0,1-1.856-2.1c-.521-.87-.959-1.823-1.423-2.8a7.271,7.271,0,0,0-1.963-2.789,9.334,9.334,0,0,0-6.252-2.02A8.258,8.258,0,0,0,1016.342,152.483Z",
    transform: "translate(-1016.342 -150.117)",
    fill: "#ffdb8a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5968",
    "data-name": "Group 5968",
    transform: "translate(325.018 373.724)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M333.237,313.255c-31.528,5.536-40.689-3.261-70.653-16.446-65.885-28.989-95.9-106.175-66.912-172.059a104.062,104.062,0,0,1,137.005-53.28,82.762,82.762,0,0,1,42.375,108.962,65.723,65.723,0,0,1-86.528,33.652A52.035,52.035,0,0,1,261.852,145.5a41.184,41.184,0,0,1,54.224-21.087,32.427,32.427,0,0,1,16.62,42.738A25.481,25.481,0,0,1,299.148,180.2,19.9,19.9,0,0,1,288.961,154a15.412,15.412,0,0,1,20.315-7.9,11.843,11.843,0,0,1,6.071,15.61,9,9,0,0,1-11.846,4.607,6.7,6.7,0,0,1-3.806-7.763,6.187,6.187,0,0,0,3.627,6.535,7.111,7.111,0,0,0,9.374-3.645,8.284,8.284,0,0,0-4.244-10.918,9.758,9.758,0,0,0-12.845,5,11.573,11.573,0,0,0,5.931,15.253,13.872,13.872,0,0,0,18.264-7.1,16.715,16.715,0,0,0-8.566-22.029,20.281,20.281,0,0,0-26.732,10.4,24.773,24.773,0,0,0,12.683,32.615,30.354,30.354,0,0,0,39.965-15.542,37.295,37.295,0,0,0-19.115-49.154A46.007,46.007,0,0,0,257.4,143.54a56.966,56.966,0,0,0,29.165,75,70.6,70.6,0,0,0,92.947-36.146,87.638,87.638,0,0,0-44.87-115.38,108.941,108.941,0,0,0-143.424,55.774c-30.07,68.343,1.066,148.407,69.408,178.478a168.239,168.239,0,0,0,67.873,14.373c9.368,0-9.3,1.583,0,0ZM305.33,158.571a.52.52,0,0,1,.682-.267.9.9,0,0,1,.464,1.189l-1.738-.764A.635.635,0,0,1,305.33,158.571Z",
    transform: "translate(21.371 3.757)",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M296.909,307.331,275,296.377V227h21.909Z",
    transform: "translate(42.053 40.497)",
    fill: "#06abff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M232.372,164l63.244,109.543L358.861,164Z",
    transform: "translate(32.797 26.817)",
    fill: "#06abff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 42.6,
    height: 38.949,
    transform: "translate(268.368 278.451)",
    fill: "#ffbc82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    d: "M-11.667,0H175.368V57.206H2.533Z",
    transform: "translate(93 268.714)",
    fill: "#fa826e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6662",
    "data-name": "Path 6662",
    d: "M-2.649,0H173.41V14.606H.575Z",
    transform: "translate(94.958 311.314)",
    fill: "#333",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 15.823,
    height: 57.206,
    transform: "translate(268.368 268.714)",
    fill: "#37718e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 64.509,
    height: 57.206,
    rx: 4,
    transform: "translate(297.579 269.931)",
    fill: "#ffbc82"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 46.252,
    height: 13.389,
    rx: 4,
    transform: "translate(296.765 282.101) rotate(-67.33)",
    fill: "#ffbc82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6366",
    "data-name": "Path 6366",
    d: "M234.334,169.334l39.759.811,28.4,71.406L278.151,244.8Z",
    transform: "translate(33.223 27.975)",
    fill: "#38bcff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6367",
    "data-name": "Path 6367",
    d: "M364.537,167.869a4.869,4.869,0,0,1-4.869,4.869h-127.8A4.869,4.869,0,0,1,227,167.869h0A4.869,4.869,0,0,1,231.869,163h127.8a4.869,4.869,0,0,1,4.869,4.869Z",
    transform: "translate(31.63 26.6)",
    fill: "#7ff6e8"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5344",
    "data-name": "Group 5344",
    transform: "translate(240.987 107.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5343",
    "data-name": "Group 5343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6368",
    "data-name": "Path 6368",
    d: "M247.236,165.182c-.473,0-.932-.013-1.4-.04a34.659,34.659,0,0,1-16.778-5.113c-.078-.041-.156-.086-.231-.133-.314-.194-.571-.365-.828-.536l-.337-.224a34.683,34.683,0,1,1,37.18,1.2c-.094.06-.2.12-.3.18-.256.142-.5.274-.739.4l-.017.018-.425.223A34.576,34.576,0,0,1,247.236,165.182ZM231.294,155.7l.229.131a29.811,29.811,0,0,0,14.536,4.446c.43.024.8.035,1.177.035A29.719,29.719,0,0,0,260.809,157l0,0,.346-.185c.33-.176.658-.352.976-.528l.19-.117a29.849,29.849,0,1,0-31.952-1.076l.323.214C230.894,155.441,231.093,155.575,231.294,155.7Z",
    transform: "translate(-212.504 -95.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6369",
    "data-name": "Path 6369",
    d: "M263.124,157.834c-.073.049-.158.1-.243.146-.329.183-.669.365-1.01.548a.267.267,0,0,1-.061.036,32.073,32.073,0,0,1-15.007,3.749c-.426,0-.84-.012-1.266-.036a32.249,32.249,0,0,1-15.725-4.808,1.572,1.572,0,0,1-.195-.11c-.353-.219-.706-.463-1.059-.694a32.234,32.234,0,0,1,2.069-54.552,32.253,32.253,0,0,1,32.5,55.721Z",
    transform: "translate(-212.07 -95.346)",
    fill: "#28848b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6370",
    "data-name": "Path 6370",
    d: "M260.617,149.1c-.073.049-.158.1-.243.146-.329.183-.669.365-1.01.548a.267.267,0,0,1-.061.037,32.073,32.073,0,0,1-15.007,3.749c-.426,0-.84-.012-1.266-.037a32.249,32.249,0,0,1-15.725-4.808,1.574,1.574,0,0,1-.195-.11c-.353-.219-.706-.463-1.059-.694q.256-.456.548-.913a17.235,17.235,0,0,1,1.217-1.7c.389-.487.8-.962,1.229-1.4.11-.122.231-.231.353-.353.414-.4.84-.779,1.278-1.144a4.569,4.569,0,0,1,.377-.3c.183-.146.365-.006.548-.14a1.461,1.461,0,0,1,.852-.323h.012c.3-1.217.6-.651.913-.822s.609-.477.925-.635c.341-.172.694-.4,1.047-.556a5.969,5.969,0,0,1,.706-.314c.134-.061.268-.127.4-.175.268-.1.536-.2.815-.276s.536-.163.815-.236c.158-.049.316-.086.475-.123.268-.061.536-.123.815-.172a20.071,20.071,0,0,1,3.651-.341,19.048,19.048,0,0,1,3.651.352,19.379,19.379,0,0,1,10.127,5.343A19.834,19.834,0,0,1,260.617,149.1Z",
    transform: "translate(-209.563 -86.612)",
    fill: "#4dc8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6371",
    "data-name": "Path 6371",
    d: "M252.909,125.747v5.282a10.748,10.748,0,0,1-7.3,10.175,10.436,10.436,0,0,1-3.445.572h-.414a10.435,10.435,0,0,1-3.444-.572A10.748,10.748,0,0,1,231,131.03v-5.282a7.788,7.788,0,0,1,.061-1.071A10.751,10.751,0,0,1,241.747,115h.414a10.78,10.78,0,0,1,10.747,10.747Z",
    transform: "translate(-208.488 -91.607)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6372",
    "data-name": "Path 6372",
    d: "M232.434,125.434a1.216,1.216,0,0,1-1.217,1.217h0A1.216,1.216,0,0,1,230,125.434v-1.217A1.216,1.216,0,0,1,231.217,123h0a1.216,1.216,0,0,1,1.217,1.217Z",
    transform: "translate(-208.705 -89.869)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M250.434,125.434a1.216,1.216,0,0,1-1.217,1.217h0A1.216,1.216,0,0,1,248,125.434v-1.217A1.216,1.216,0,0,1,249.217,123h0a1.216,1.216,0,0,1,1.217,1.217Z",
    transform: "translate(-204.797 -89.869)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M244.3,131.043v9.737c0,1.68-1.68,3.043-3.651,3.043a4.076,4.076,0,0,1-2.568-.889A2.794,2.794,0,0,1,237,140.78v-9.737c0-1.68,1.68-3.043,3.651-3.043a4.076,4.076,0,0,1,2.568.889A2.794,2.794,0,0,1,244.3,131.043Z",
    transform: "translate(-207.185 -88.784)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M242.869,132.217a1.216,1.216,0,0,1-1.217,1.217h-2.434A1.216,1.216,0,0,1,238,132.217h0A1.216,1.216,0,0,1,239.217,131h2.434a1.216,1.216,0,0,1,1.217,1.217Z",
    transform: "translate(-206.968 -88.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M251.893,118.051a6.186,6.186,0,0,1-1.315,1.12c-2.434,1.57-5.55,1.168-8.569,1.168a17.207,17.207,0,0,0-2.982.219,17.386,17.386,0,0,0-7.911,4.272l-.061.061a5.57,5.57,0,0,1,1.351-5.915,7.806,7.806,0,0,1,2.6-1.692,9.278,9.278,0,0,1,7-2.994,13.564,13.564,0,0,1,4.017.694A20.839,20.839,0,0,1,251.893,118.051Z",
    transform: "translate(-208.544 -91.761)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M243.5,119.438s1.014,3.956,6.694,4.665c0,0-.2-5.172-2.13-6.187Z",
    transform: "translate(-205.774 -90.973)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 1.217,
    height: 3.651,
    transform: "translate(22.512 31.913)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 1.217,
    height: 3.651,
    transform: "translate(43.203 31.913)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M243.029,114.29v44.4a32.249,32.249,0,0,1-15.725-4.808,1.574,1.574,0,0,1-.195-.11c-.353-.219-.706-.463-1.059-.694q.256-.456.548-.913a17.235,17.235,0,0,1,1.217-1.7c.389-.487.8-.962,1.229-1.4.11-.122.231-.231.353-.353.414-.4.84-.779,1.278-1.144a4.569,4.569,0,0,1,.377-.3c.183-.146.365-.006.548-.14a1.461,1.461,0,0,1,.852-.323h.012c.3-1.217.6-.651.913-.822s.609-.477.925-.635c.341-.172.694-.4,1.047-.556a5.969,5.969,0,0,1,.706-.314c.134-.061.268-.127.4-.175.268-.1.536-.2.815-.276s.536-.163.815-.236c.158-.049.316-.086.475-.123.268-.061.536-.124.815-.173v-2.13a10.748,10.748,0,0,1-7.3-10.175V124.83a.086.086,0,0,1-.03.061,5.569,5.569,0,0,1,1.367-5.915,7.785,7.785,0,0,1,2.612-1.692A9.3,9.3,0,0,1,243.029,114.29Z",
    transform: "translate(-209.563 -91.761)",
    fill: "#fff",
    opacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5346",
    "data-name": "Group 5346",
    transform: "translate(348.096 56.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5345",
    "data-name": "Group 5345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M335.236,123.182c-.473,0-.932-.013-1.4-.04a34.659,34.659,0,0,1-16.778-5.113c-.078-.043-.156-.086-.231-.133-.314-.194-.571-.365-.828-.536l-.337-.223a34.683,34.683,0,1,1,37.18,1.2c-.094.06-.2.12-.3.18-.256.142-.5.274-.739.4l-.017.018-.425.224A34.59,34.59,0,0,1,335.236,123.182ZM319.294,113.7l.229.131a29.824,29.824,0,0,0,14.536,4.446c.43.024.8.035,1.177.035A29.719,29.719,0,0,0,348.809,115l0,0,.346-.185c.33-.176.659-.352.976-.528l.19-.117a29.848,29.848,0,1,0-31.952-1.076l.323.214C318.894,113.441,319.093,113.575,319.294,113.7Z",
    transform: "translate(-300.504 -53.779)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M351.124,115.834c-.073.049-.158.1-.243.146-.329.184-.669.365-1.01.548a.314.314,0,0,1-.061.038,32.087,32.087,0,0,1-15.007,3.748c-.426,0-.84-.012-1.266-.037a32.249,32.249,0,0,1-15.726-4.808,1.573,1.573,0,0,1-.195-.11c-.353-.219-.706-.463-1.059-.694a32.235,32.235,0,0,1,2.069-54.552,32.253,32.253,0,0,1,32.5,55.721Z",
    transform: "translate(-300.07 -53.345)",
    fill: "#28848b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M348.617,107.1c-.073.049-.158.1-.243.146-.329.184-.669.365-1.01.548a.315.315,0,0,1-.061.038,32.087,32.087,0,0,1-15.007,3.748c-.426,0-.84-.012-1.266-.037a32.249,32.249,0,0,1-15.725-4.808,1.571,1.571,0,0,1-.195-.11c-.353-.219-.706-.463-1.059-.694q.256-.456.548-.913a17.233,17.233,0,0,1,1.217-1.7c.389-.488.8-.96,1.229-1.4.11-.12.231-.23.353-.352.414-.4.84-.779,1.278-1.144a4.575,4.575,0,0,1,.377-.3c.183-.146.365-.006.548-.139a1.463,1.463,0,0,1,.852-.324h.012c.3-1.217.6-.651.913-.822s.609-.477.925-.635c.341-.172.694-.4,1.047-.556a5.971,5.971,0,0,1,.706-.314c.134-.061.268-.127.4-.175.268-.1.536-.2.815-.276s.536-.162.815-.236c.158-.049.316-.086.475-.123.268-.061.536-.124.815-.172A20.181,20.181,0,0,1,331.029,96a19.048,19.048,0,0,1,3.651.353,19.388,19.388,0,0,1,10.127,5.343A19.871,19.871,0,0,1,348.617,107.1Z",
    transform: "translate(-297.563 -44.611)",
    fill: "#ff6349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M340.909,83.747V89.03a10.748,10.748,0,0,1-7.3,10.175,10.435,10.435,0,0,1-3.444.572h-.414a10.435,10.435,0,0,1-3.445-.572A10.748,10.748,0,0,1,319,89.03V83.747a7.8,7.8,0,0,1,.061-1.071A10.751,10.751,0,0,1,329.747,73h.414a10.78,10.78,0,0,1,10.747,10.747Z",
    transform: "translate(-296.488 -49.605)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M320.434,83.434a1.216,1.216,0,0,1-1.217,1.217h0A1.216,1.216,0,0,1,318,83.434V82.217A1.216,1.216,0,0,1,319.217,81h0a1.216,1.216,0,0,1,1.217,1.217Z",
    transform: "translate(-296.705 -47.868)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M338.434,83.434a1.216,1.216,0,0,1-1.217,1.217h0A1.216,1.216,0,0,1,336,83.434V82.217A1.216,1.216,0,0,1,337.217,81h0a1.216,1.216,0,0,1,1.217,1.217Z",
    transform: "translate(-292.797 -47.868)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M332.3,89.043V98.78c0,1.68-1.68,3.043-3.651,3.043a4.076,4.076,0,0,1-2.568-.889A2.794,2.794,0,0,1,325,98.78V89.043c0-1.68,1.68-3.043,3.651-3.043a4.076,4.076,0,0,1,2.568.889A2.794,2.794,0,0,1,332.3,89.043Z",
    transform: "translate(-295.185 -46.782)",
    fill: "#ffc497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M330.869,90.217a1.216,1.216,0,0,1-1.217,1.217h-2.434A1.216,1.216,0,0,1,326,90.217h0A1.216,1.216,0,0,1,327.217,89h2.434a1.216,1.216,0,0,1,1.217,1.217Z",
    transform: "translate(-294.968 -46.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M339.893,76.051a6.187,6.187,0,0,1-1.314,1.12c-2.434,1.57-5.55,1.168-8.569,1.168a17.207,17.207,0,0,0-2.982.219,17.386,17.386,0,0,0-7.911,4.272l-.061.061a5.57,5.57,0,0,1,1.351-5.915,7.806,7.806,0,0,1,2.6-1.692,9.278,9.278,0,0,1,7-2.994,13.563,13.563,0,0,1,4.017.694A20.84,20.84,0,0,1,339.893,76.051Z",
    transform: "translate(-296.544 -49.76)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M331.5,77.438s1.014,3.956,6.694,4.665c0,0-.2-5.172-2.13-6.187Z",
    transform: "translate(-293.774 -48.972)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 1.217,
    height: 3.651,
    transform: "translate(22.512 31.915)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 1.217,
    height: 3.651,
    transform: "translate(43.203 31.915)",
    fill: "#ff9f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6389",
    "data-name": "Path 6389",
    d: "M331.029,72.29v44.4a32.249,32.249,0,0,1-15.725-4.808,1.571,1.571,0,0,1-.195-.11c-.353-.219-.706-.463-1.059-.694q.256-.456.548-.913a17.233,17.233,0,0,1,1.217-1.7c.389-.488.8-.96,1.229-1.4.11-.12.231-.23.353-.352.414-.4.84-.779,1.278-1.144a4.575,4.575,0,0,1,.377-.3c.183-.146.365-.006.548-.139a1.463,1.463,0,0,1,.852-.324h.012c.3-1.217.6-.651.913-.822s.609-.477.925-.635c.341-.172.694-.4,1.047-.556a5.971,5.971,0,0,1,.706-.314c.134-.061.268-.127.4-.175.268-.1.536-.2.815-.276s.536-.162.815-.236c.158-.049.316-.086.475-.123.268-.061.536-.124.815-.174v-2.13a10.745,10.745,0,0,1-7.3-10.174V82.83a.086.086,0,0,1-.03.061,5.567,5.567,0,0,1,1.367-5.914,7.777,7.777,0,0,1,2.612-1.693A9.29,9.29,0,0,1,331.029,72.29Z",
    transform: "translate(-297.563 -49.76)",
    fill: "#fff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5367",
    "data-name": "Group 5367",
    transform: "translate(268.976 41.717)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5350",
    "data-name": "Group 5350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5349",
    "data-name": "Group 5349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5347",
    "data-name": "Group 5347",
    transform: "translate(0.609 0.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6390",
    "data-name": "Path 6390",
    d: "M282.251,65.126A23.126,23.126,0,1,1,259.126,42,23.116,23.116,0,0,1,282.251,65.126Z",
    transform: "translate(-236 -42)",
    fill: "#28848b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5348",
    "data-name": "Group 5348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6391",
    "data-name": "Path 6391",
    d: "M259.234,88.969a23.742,23.742,0,1,1,11.243-2.835A23.7,23.7,0,0,1,259.234,88.969Zm0-46.251a22.515,22.515,0,0,0-10.666,42.344,22.863,22.863,0,0,0,21.33,0,22.515,22.515,0,0,0-10.665-42.346Z",
    transform: "translate(-235.5 -41.5)",
    fill: "#fff"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5352",
    "data-name": "Group 5352",
    transform: "translate(13.693 21.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5351",
    "data-name": "Group 5351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6392",
    "data-name": "Path 6392",
    d: "M248.734,61.065a1.359,1.359,0,0,1-.463,1.088.711.711,0,0,1-.536.147c-.548,0-.986-.712-.986-1.528s.438-1.5.986-1.5c.195,0,.365.409.523.555l.012.336h.012C248.551,60.159,248.734,60.553,248.734,61.065Z",
    transform: "translate(-246.75 -59.268)",
    fill: "#ffd7a2"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5354",
    "data-name": "Group 5354",
    transform: "translate(31.95 21.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5353",
    "data-name": "Group 5353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6393",
    "data-name": "Path 6393",
    d: "M263.728,60.734c0,.819-.442,1.484-.99,1.484s-.988-.665-.988-1.484.442-1.484.988-1.484S263.728,59.915,263.728,60.734Z",
    transform: "translate(-261.75 -59.25)",
    fill: "#ffd7a2"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5356",
    "data-name": "Group 5356",
    transform: "translate(12.78 34.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5355",
    "data-name": "Group 5355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6394",
    "data-name": "Path 6394",
    d: "M267.909,72.826v6.366a23.1,23.1,0,0,1-21.909,0V72.826c0-1.339,1.1-1.826,2.434-1.826h17.04C266.813,71,267.909,71.487,267.909,72.826Z",
    transform: "translate(-246 -71)",
    fill: "#fab55c"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5358",
    "data-name": "Group 5358",
    transform: "translate(15.214 13.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5357",
    "data-name": "Group 5357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6395",
    "data-name": "Path 6395",
    d: "M265.04,60.923v2.532a8.515,8.515,0,0,1-6.086,8.167A8.522,8.522,0,0,1,248,63.454v-2.5a8.52,8.52,0,0,1,17.04-.037Z",
    transform: "translate(-248 -52.5)",
    fill: "#ffd7a2"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5360",
    "data-name": "Group 5360",
    transform: "translate(21.3 28.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5359",
    "data-name": "Group 5359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 4.869,
    height: 9.737,
    rx: 1.88,
    fill: "#ffd7a2"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5362",
    "data-name": "Group 5362",
    transform: "translate(15.104 13.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5361",
    "data-name": "Group 5361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6396",
    "data-name": "Path 6396",
    d: "M265.072,60.984l-.012-.024-.84-1.8a6.951,6.951,0,0,1-4.029-2.434A6.631,6.631,0,0,1,256.54,58.5c-2.824.4-5.38-1.071-7.157-.341-.669.292-1.254,2.459-1.351,2.836a.213.213,0,0,0-.012.061c0-.024-.012-.049-.012-.073-.694-3.761,2.519-6.159,2.519-6.159a8.172,8.172,0,0,1,6.013-2.5,9.39,9.39,0,0,1,4.723,1.5A7.309,7.309,0,0,1,265.072,60.984Z",
    transform: "translate(-247.909 -52.328)",
    fill: "#ff6628"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5364",
    "data-name": "Group 5364",
    transform: "translate(32.254 21.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5363",
    "data-name": "Group 5363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M262.073,59.586,262,59.513a.34.34,0,0,1,.012-.073l.049.122Z",
    transform: "translate(-262 -59.44)",
    fill: "#ff6628"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5366",
    "data-name": "Group 5366",
    transform: "translate(12.78 13.179)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5365",
    "data-name": "Group 5365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M256.954,52.331V86.009A22.965,22.965,0,0,1,246,83.246V76.88c0-1.339,1.1-1.826,2.434-1.826h6.086v-3.4a8.525,8.525,0,0,1-6.086-8.167.791.791,0,0,1-.536.231c-.548,0-.986-.669-.986-1.485s.438-1.485.986-1.485a.763.763,0,0,1,.523.231c-.694-3.761,2.519-6.159,2.519-6.159A8.172,8.172,0,0,1,256.954,52.331Z",
    transform: "translate(-246 -52.328)",
    fill: "#fff"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5370",
    "data-name": "Group 5370",
    transform: "translate(364.826 139.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5368",
    "data-name": "Group 5368",
    transform: "translate(0 0.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M326.072,147.2a10.939,10.939,0,1,1-7.674-19.788v-6.594a17.509,17.509,0,1,0,12.689,30.8Z",
    transform: "translate(-302.25 -120.814)",
    fill: "#375ef5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5369",
    "data-name": "Group 5369",
    transform: "translate(18.338 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6400",
    "data-name": "Path 6400",
    d: "M329.127,138.264a10.894,10.894,0,0,1-2.979,7.483l4.926,4.344A17.479,17.479,0,0,0,319,120.788v6.569A10.955,10.955,0,0,1,329.127,138.264Z",
    transform: "translate(-319 -120.788)",
    fill: "#fa826e"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5398",
    "data-name": "Group 5398",
    transform: "translate(191.079 95.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5396",
    "data-name": "Group 5396",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 21.909,
    cy: 21.909,
    r: 21.909,
    fill: "#fa826e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5397",
    "data-name": "Group 5397",
    transform: "translate(15.214 13.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6402",
    "data-name": "Path 6402",
    d: "M187.312,113.032c-1.766,1.018-3.312.185-3.312-1.852V99.343c0-2.036,1.546-2.869,3.312-1.85l10.3,5.917c1.762,1.02,1.738,2.685-.026,3.7Z",
    transform: "translate(-184 -97.058)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5399",
    "data-name": "Group 5399",
    transform: "translate(218.16 40.5)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    d: "M3.313,0h1.9A3.312,3.312,0,0,1,8.52,3.312v9.2a3.313,3.313,0,0,1-3.312,3.313H3.313A3.313,3.313,0,0,1,0,12.51v-9.2A3.313,3.313,0,0,1,3.313,0Z",
    transform: "translate(5.173 12.78)",
    fill: "#585d69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6403",
    "data-name": "Path 6403",
    d: "M204.546,51.529a4,4,0,0,1,.643,2.171V61.46a4.031,4.031,0,0,1-4.032,4.031H200.7a4,4,0,0,1-2.171-.644,4.023,4.023,0,0,0,3.389,1.861h.456a4.031,4.031,0,0,0,4.032-4.031V54.918A4.018,4.018,0,0,0,204.546,51.529Z",
    transform: "translate(-192.712 -38.105)",
    fill: "#ffa941",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6404",
    "data-name": "Path 6404",
    d: "M213.224,50.237a9.737,9.737,0,1,0-15.4,7.911h11.322A9.713,9.713,0,0,0,213.224,50.237Z",
    transform: "translate(-193.75 -40.5)",
    fill: "#f6ce5e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 10.954,
    height: 6.086,
    transform: "translate(3.956 17.649)",
    fill: "#585d69"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 10.954,
    height: 2.434,
    transform: "translate(3.956 17.649)",
    fill: "#797d87"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 1.065,
    cy: 1.065,
    r: 1.065,
    transform: "translate(3.804 4.412)",
    fill: "#f6fbfb"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5533",
    "data-name": "Group 5533",
    transform: "translate(303.822 355.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 21.909,
    cy: 21.909,
    r: 21.909,
    transform: "translate(0 0)",
    fill: "#fad733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6415",
    "data-name": "Path 6415",
    d: "M286.038,299.071a21.909,21.909,0,1,0,21.909,21.909A21.911,21.911,0,0,0,286.038,299.071Zm0,42.131A20.222,20.222,0,1,1,306.26,320.98,20.245,20.245,0,0,1,286.038,341.2Z",
    transform: "translate(-264.129 -299.071)",
    fill: "#fca900"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 16.852,
    cy: 16.852,
    r: 16.852,
    transform: "translate(5.057 5.057)",
    fill: "#fca900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531",
    transform: "translate(15.152 8.095)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6416",
    "data-name": "Path 6416",
    d: "M284.586,318.1l1.727.484a5.529,5.529,0,0,1,3.294,2.061,6.918,6.918,0,0,1,.955,3.885q0,3.491-1.579,4.624t-5.581,1.141l-.275,3.426h-1.545l.273-3.457a38.754,38.754,0,0,1-5.007-.578l.214-2.337,5.035.122.545-6.854-1.911-.516a5.3,5.3,0,0,1-3.2-2.048,6.948,6.948,0,0,1-.955-3.9,9.129,9.129,0,0,1,.377-2.9,3.041,3.041,0,0,1,1.319-1.683,5.662,5.662,0,0,1,2.094-.761,20.706,20.706,0,0,1,3.093-.181h.333l.214-2.911h1.515l-.212,2.971a21.728,21.728,0,0,1,4.458.578l-.181,2.215q-2.669-.124-4.489-.122Zm-1.518-.428.514-6.34a6.971,6.971,0,0,0-3.152.471q-.791.471-.789,2.444a3.339,3.339,0,0,0,.56,2.185,3.924,3.924,0,0,0,1.989,1Zm1.063,3.369-.515,6.43a5.613,5.613,0,0,0,3.06-.576,2.845,2.845,0,0,0,.792-2.4,3.431,3.431,0,0,0-.548-2.225,3.863,3.863,0,0,0-1.941-.988Z",
    transform: "translate(-276.578 -305.722)",
    fill: "#f7f7f7"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536",
    transform: "translate(344.577 391.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 14.606,
    cy: 14.606,
    r: 14.606,
    transform: "translate(1.157 1.157)",
    fill: "#fad733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6417",
    "data-name": "Path 6417",
    d: "M313.169,329.506a14.606,14.606,0,1,0,14.606,14.606A14.607,14.607,0,0,0,313.169,329.506Zm0,28.088a13.481,13.481,0,1,1,13.482-13.482A13.5,13.5,0,0,1,313.169,357.594Z",
    transform: "translate(-297.407 -328.349)",
    fill: "#fca900"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 11.235,
    cy: 11.235,
    r: 11.235,
    transform: "matrix(0.79, -0.613, 0.613, 0.79, 0, 13.767)",
    fill: "#fca900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534",
    transform: "translate(11.257 6.554)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6418",
    "data-name": "Path 6418",
    d: "M312.2,342.192l1.151.323a3.683,3.683,0,0,1,2.2,1.374,4.6,4.6,0,0,1,.638,2.589q0,2.33-1.053,3.083a6.655,6.655,0,0,1-3.72.761l-.184,2.283H310.2l.181-2.3a25.453,25.453,0,0,1-3.337-.386l.142-1.557q2.587.06,3.357.082l.364-4.569-1.274-.346a3.517,3.517,0,0,1-2.132-1.366,4.625,4.625,0,0,1-.638-2.6,6.114,6.114,0,0,1,.252-1.933,2.031,2.031,0,0,1,.88-1.122,3.8,3.8,0,0,1,1.395-.506,13.741,13.741,0,0,1,2.062-.122h.223l.144-1.94h1.01l-.141,1.98a14.55,14.55,0,0,1,2.972.386l-.122,1.476q-1.778-.082-2.993-.082Zm-1.011-.286.343-4.226a4.647,4.647,0,0,0-2.1.314c-.352.208-.526.752-.526,1.627a2.228,2.228,0,0,0,.374,1.458,2.619,2.619,0,0,0,1.326.666Zm.708,2.246-.343,4.288a3.75,3.75,0,0,0,2.041-.385,1.9,1.9,0,0,0,.527-1.6,2.283,2.283,0,0,0-.365-1.484,2.555,2.555,0,0,0-1.294-.66Z",
    transform: "translate(-306.862 -333.94)",
    fill: "#f7f7f7"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5539",
    "data-name": "Group 5539",
    transform: "translate(308.305 412.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5538",
    "data-name": "Group 5538"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 14.606,
    cy: 14.606,
    r: 14.606,
    fill: "#fad733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    "data-name": "Path 6419",
    d: "M282.418,346.018a14.606,14.606,0,1,0,14.606,14.606A14.607,14.607,0,0,0,282.418,346.018Zm0,28.088A13.482,13.482,0,1,1,295.9,360.624,13.5,13.5,0,0,1,282.418,374.106Z",
    transform: "translate(-267.812 -346.018)",
    fill: "#fca900"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 11.235,
    cy: 11.235,
    r: 11.235,
    transform: "matrix(0.062, -0.998, 0.998, 0.062, 2.695, 25.121)",
    fill: "#fca900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5537",
    "data-name": "Group 5537",
    transform: "translate(10.101 5.396)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6420",
    "data-name": "Path 6420",
    d: "M281.449,358.7l1.151.324a3.679,3.679,0,0,1,2.2,1.374,4.608,4.608,0,0,1,.637,2.589q0,2.328-1.052,3.083a6.657,6.657,0,0,1-3.721.761l-.183,2.283h-1.031l.181-2.3a25.457,25.457,0,0,1-3.337-.386l.142-1.557q2.589.06,3.357.08l.364-4.569-1.274-.344a3.531,3.531,0,0,1-2.132-1.366,4.637,4.637,0,0,1-.637-2.6,6.089,6.089,0,0,1,.252-1.933,2.042,2.042,0,0,1,.879-1.122,3.823,3.823,0,0,1,1.4-.505,13.738,13.738,0,0,1,2.062-.122h.223l.142-1.941h1.01l-.141,1.982a14.455,14.455,0,0,1,2.972.386l-.12,1.475q-1.78-.08-2.993-.08Zm-1.013-.285.343-4.227a4.65,4.65,0,0,0-2.1.314q-.526.314-.525,1.629a2.229,2.229,0,0,0,.372,1.457,2.609,2.609,0,0,0,1.327.666Zm.71,2.246-.343,4.287a3.745,3.745,0,0,0,2.04-.383,1.9,1.9,0,0,0,.528-1.6,2.271,2.271,0,0,0-.366-1.482,2.546,2.546,0,0,0-1.294-.66Z",
    transform: "translate(-276.111 -350.451)",
    fill: "#f7f7f7"
  }))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 3.043,
    cy: 3.043,
    r: 3.043,
    transform: "translate(272.628 311.923)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadm);
export default __webpack_public_path__ + "static/media/leadm.722b752ae8ce0833451207fe3e25b176.svg";
export { ForwardRef as ReactComponent };